import { render } from "./IssueEdit.vue?vue&type=template&id=4f152a34&scoped=true"
import script from "./IssueEdit.vue?vue&type=script&lang=js"
export * from "./IssueEdit.vue?vue&type=script&lang=js"

import "./IssueEdit.vue?vue&type=style&index=0&id=4f152a34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f152a34"]])

export default __exports__